import { useState } from "react";
import Dropdown from "../Elements/Dropdown";
import ProgressBar from "../Elements/ProgressBar";
import { TbEdit, TbTrash, TbEye } from "react-icons/tb";
import Popup from "../Elements/Popup";
import { useNavigate, Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import PropTypes from "prop-types";

const GoalCard = ({ goalMilestones, title, onEdit, onDelete, goal }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false); // manage popup state
  const navigate = useNavigate();
  const { copy } = useLanguage();

  const progressPercentage =
    goalMilestones.length > 0
      ? Math.round(
          (goalMilestones.filter((milestone) => milestone.status === true)
            .length /
            goalMilestones.length) *
            100
        )
      : 0;

  const handleDeleteConfirm = () => {
    onDelete(goal.id); // call the delete function passed from parent
    setConfirmDeleteOpen(false); // close popup after confirming
  };

  const goalDropdown = [
    {
      text: copy.card_goal.dropdown.view,
      onClick: () => navigate(`/goals/${goal.id}`),
      icon: <TbEye />,
    },
    {
      text: copy.card_goal.dropdown.edit,
      onClick: () => onEdit(goal),
      icon: <TbEdit />,
    },
    {
      text: copy.card_goal.dropdown.delete,
      onClick: () => setConfirmDeleteOpen(true), // open popup instead of deleting immediately
      icon: <TbTrash />,
    },
  ];

  return (
    <>
      <Link
        to={`/goals/${goal.id}`}
        className="relative p-3 card-base-background card-base flex flex-col justify-between card-base-border hover:shadow-lg transition-shadow cursor-pointer group"
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div className="flex flex-col gap-2 w-[85%] mr-5!">
          <p className="">{title}</p>
          <ProgressBar
            width={`${progressPercentage}%`}
            percentage={progressPercentage}
          />
        </div>
        <div
          className="absolute top-4 right-2 z-10"
          onClick={(e) => e.preventDefault()}
        >
          <Dropdown
            options={goalDropdown}
            isOpen={dropdownOpen}
            onOpenChange={setDropdownOpen}
          />
        </div>
      </Link>

      {/* Delete confirmation popup */}
      <Popup
        isOpen={confirmDeleteOpen}
        onClose={() => setConfirmDeleteOpen(false)}
        title={copy.card_goal.popup.delete_title}
        description={copy.card_goal.popup.delete_description}
        buttonSecondaryCTA={copy.dropdown.cancel}
        onClickSecondaryLink={() => setConfirmDeleteOpen(false)}
        buttonPrimaryCTA={copy.dropdown.delete}
        onClickPrimaryLink={handleDeleteConfirm}
      />
    </>
  );
};

GoalCard.propTypes = {
  goalMilestones: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  goal: PropTypes.object.isRequired,
};

export default GoalCard;
